import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Observable, map } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { SessionExpiredService } from '../../services/session-expired.service';

@Component({
  selector: 'app-session-expired-overlay',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './session-expired-overlay.component.html',
  styleUrls: ['./session-expired-overlay.component.scss']
})
export class SessionExpiredOverlayComponent {
  readonly titleKey$: Observable<string>;
  readonly messageKey$: Observable<string>;

  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionExpiredService: SessionExpiredService
  ) {
    this.titleKey$ = this.sessionExpiredService.reason$.pipe(
      map(reason => reason === 'updated' ? 'sessionExpired.updatedTitle' : 'sessionExpired.title')
    );
    this.messageKey$ = this.sessionExpiredService.reason$.pipe(
      map(reason => reason === 'updated' ? 'sessionExpired.updatedMessage' : 'sessionExpired.message')
    );
  }

  goToLogin(): void {
    this.sessionExpiredService.hide();
    this.authService.logout().subscribe({
      complete: () => this.router.navigate(['/login'])
    });
  }
}
